import { render } from "./MyAccount.vue?vue&type=template&id=7c08d720&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"

import "./MyAccount.vue?vue&type=style&index=0&id=7c08d720&scoped=true&lang=css"
import "./MyAccount.vue?vue&type=style&index=1&id=7c08d720&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c08d720"]])

export default __exports__